import { passwordValidation } from 'src/lib'
import { z } from 'zod'

export const loginZodSchema = z.object({
  password: z.string().regex(passwordValidation, {
    message: 'Your password is not valid',
  }),
  username: z.string().nonempty({ message: 'Please enter your username' }),
})

export type loginType = z.infer<typeof loginZodSchema>
